import { browserAgent } from './agent';

export const setPageAction = (
  name: string,
  attributes?: Record<string, string | number | boolean>,
): void => {
  browserAgent.addPageAction(name, attributes);
};
